import React from 'react';
import { graphql } from 'gatsby';
import Layout from '../components/Layout/layout';
import Seo from '../components/seo';
import '../styles/styles.sass';
import useLanguage from '../hooks/useLanguage';

import { servicesStatic } from '../db/servicesStatic';
import { servicesData } from '../db/servicesData';
// import { contactsData } from '../db/contactsData';
// import { promoCodeData } from '../db/promoСodeData';
import {
  ServicesApproach,
  ServicesMainScreen,
  ServicesPackages,
  ServicesFaq,
  DownloadPdf,
  FreeLesson,
  CrumbsNav,
  Ticker,
} from '../components/Pages/Services';

const ServicesPage = ({ data }) => {
  const servicesDatas = data.strapiServices;
  const langToggle = useLanguage;

  return (
    <Layout>
      <Seo
        title={langToggle(
          servicesDatas.seo_title_ua,
          servicesDatas.seo_title_ru
        )}
        description={langToggle(
          servicesDatas.seo_description_ua,
          servicesDatas.seo_description_ru
        )}
        keywords={[
          langToggle(
            servicesDatas.seo_keywords_ua,
            servicesDatas.seo_keywords_ru
          ),
        ]}
      />
      <ServicesMainScreen
        mainData={servicesDatas.services_main}
        mainStatic={servicesStatic.main_scroll}
        mainSocials={data.strapiContacts.Socials}
        freeLessonData={servicesDatas.trial_lesson}
      />
      <Ticker tickerData={servicesData.services_packages.ticker} />
      <ServicesPackages
        packagesData={servicesDatas.services_packages}
        promoData={data.strapiPromocode.promocode}
        autoScrollToFirstPack
      />
      <ServicesApproach approachData={servicesDatas.Approach} />
      <DownloadPdf downloadPdfData={servicesDatas.services_guides} />
      <ServicesFaq faqData={servicesDatas.services_faq} />
      <FreeLesson freeLessonData={servicesDatas.trial_lesson} />
      <CrumbsNav
        crumbsData={servicesStatic.crumbs_nav}
        crumbsCat={servicesDatas}
      />
    </Layout>
  );
};

export default ServicesPage;

export const query = graphql`
  query Services($language: String!, $id: String!) {
    strapiServices(id: { eq: $id }) {
      seo_title_ua
      seo_title_ru
      seo_description_ua
      seo_description_ru
      seo_keywords_ua
      seo_keywords_ru
      title_ua
      title_ru
      slug
      services_main {
        title_01_ua
        title_02_ua
        title_03_ua
        title_01_ru
        title_02_ru
        title_03_ru
      }
      services_packages {
        ticker {
          id
          ticker_ua
          ticker_ru
        }
        Titles {
          title_ua
          title_ru
          sub_title_ua
          sub_title_ru
        }
        Packages {
          duration_ua
          duration_ru
          rate_ua
          rate_ru
          number_lessons
          price_rub
          price_uah
          price_usd
          price_eur
          sale_uah
          sale_rub
          sale_usd
          sale_eur
        }
      }
      Approach {
        title_ua
        title_ru
        items {
          count
          title_ua
          title_ru
        }
      }
      services_guides {
        marker_ua
        marker_ru
        title_ua
        title_ru
        pdf_ua {
          url
        }
        # pdf_ru {
        #   url
        # }
      }
      services_faq {
        title_ua
        title_ru
        Items {
          id
          question_ua
          question_ru
          answer_ua
          answer_ru
        }
      }
      trial_lesson {
        title_ua
        title_ru
      }
    }
    strapiPromocode {
      promocode {
        promocode
      }
    }
    strapiContacts {
      Socials {
        title
        link
      }
    }
    locales: allLocale(filter: { language: { eq: $language } }) {
      edges {
        node {
          ns
          data
          language
        }
      }
    }
  }
`;
